import { render, staticRenderFns } from "./Davis.vue?vue&type=template&id=52ef97a7"
import script from "./Davis.vue?vue&type=script&lang=js"
export * from "./Davis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports